import BaseUtil from "../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    isClientSelect: false,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
